/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmIndividualTaxInformation} from '../api'

export const useMutationConfirmIndividualTaxInformation = createReactQueryMutationHook('confirmIndividualTaxInformation', confirmIndividualTaxInformation)
